import { render, staticRenderFns } from "./lookd.vue?vue&type=template&id=1aac43ee&scoped=true"
import script from "./lookd.vue?vue&type=script&lang=js"
export * from "./lookd.vue?vue&type=script&lang=js"
import style0 from "./lookd.vue?vue&type=style&index=0&id=1aac43ee&scoped=true&lang=scss"
import style1 from "./lookd.vue?vue&type=style&index=1&id=1aac43ee&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac43ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aac43ee')) {
      api.createRecord('1aac43ee', component.options)
    } else {
      api.reload('1aac43ee', component.options)
    }
    module.hot.accept("./lookd.vue?vue&type=template&id=1aac43ee&scoped=true", function () {
      api.rerender('1aac43ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/lookd.vue"
export default component.exports